module.exports = __webpack_public_path__ + "static/media/rotateLeft.146af760.svg";